import { CHAIN_TYPE } from '@formo/shared';

export function readableTokenBalance(value: number | string, type: CHAIN_TYPE) {
  const balance = Number(value);
  return balance / (type === CHAIN_TYPE.SOLANA ? 10 ** 9 : 10 ** 18);
}
